// Module
var code = "<h3 class=\"arcade-title hidden-sm hidden-xs\" translate=\"LAYOUT.ARCADE_TITLE\"></h3> <span class=\"logo-left hidden-xs\" ng-if=\"$ctrl.environmentLabel\" ng-style=\"$ctrl.environmentLabel.style\">{{$ctrl.environmentLabel.text}}</span> ";
// Exports
module.exports = code;